import { server_ip } from "../config";

export async function fetchPromotions( filter, options , project=null) {
    try {
        const response = await fetch(`${server_ip}/api/promotions/fetch`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                filter,
                options,
                ...project?{project}:{}
            })
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}
export async function fetchPromotionById(_id) {
    try {
        const response = await fetch(`${server_ip}/api/promotions/${_id}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            }
        });
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' };
    }
}

export async function insertPromotion(token, data) {
    try {
        const response = await fetch(`${server_ip}/api/promotions`, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}
export async function updatePromotion(token, _id, data) {
    try {
        const response = await fetch(`${server_ip}/api/promotions/${_id}`, {
            method: 'PUT',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                data
            })
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}

export async function deletePromotion(token, _id) {
    try {
        const response = await fetch(`${server_ip}/api/promotions/${_id}`, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            }
        })
        return await response.json();
    } catch (error) {
        return { errno: 1, message: 'Unexpected error' }
    }
}